/*
Executes a parameterised search URL with a search term taken from the value of the
.external-search__term element

.external-search              scope container
                              [data-external-search-url] (Required) Search URL
  .external-search__trigger   trigger for submitting search
  .external-search__term      usuallt form input, provides search term
*/
const $document = $(document);

function search($trigger) {
  const $container = $trigger.closest('.external-search');
  window.open(
    $container.data('external-search-url') +
      $container.find('.external-search__term').val().trim(),
    '_self'
  );
}

$document.on('click', '.external-search__trigger', (e) => {
  search($(e.currentTarget));
});

$document.on('keyup', '.external-search__term', (e) => {
  switch (e.keyCode) {
    case 13: // Enter key
      search($(e.currentTarget));
      return true;
    default:
      return false;
  }
});
